import { Inject, Injectable } from "@angular/core";
import { AppDataService } from "@app/services/appData.service";
import { WindowToken } from "@app/util/window.token";
import { Router } from "@angular/router";
import { UserStore } from "@app/services/stores/UserStore";
import { MatDialog } from "@angular/material/dialog";
import { OneButtonDialogComponent } from "@app/components/sharedDialogs/oneButtonDialog.component";

@Injectable({ providedIn: "root" })
export class LogoutService {

    redirectUrl: string;

    constructor(@Inject(WindowToken) public window,
                @Inject(AppDataService) private appDataService: AppDataService,
                @Inject(UserStore) private userStore: UserStore,
                @Inject(MatDialog) private dialog: MatDialog,
                @Inject(Router) private router: Router) {
        this.logout = this.logout.bind(this)
        this.window["logoutFromAMUI"] = this.logout.bind(this)
    }

    logout() {
        let idToken: string = this.window.sessionStorage.getItem("hoapay_idToken");
        this.window.localStorage.removeItem("hoapay_idToken");
        this.window.sessionStorage.removeItem("hoapay_idToken");
        this.window.sessionStorage.removeItem("hoapay_accessToken");
        this.window.sessionStorage.removeItem("hoapay_hasReceivedToken");

        // web
       if (!idToken) {
            this.redirectUrl = this.appDataService.appConfig.get_APP_ENV().HOAPASS_WEB_URL;
            this.window.location.href = this.redirectUrl;
        } else {
            this.redirectUrl =  this.appDataService.appConfig.get_APP_ENV().OAUTH_LOGOUT_URL + 'id_token_hint=' +
                idToken + '&post_logout_redirect_uri=' + this.appDataService.appConfig.get_APP_ENV().OAUTH_LOGOUT_REDIRECT_URL;
            this.window.location.href = this.redirectUrl;
        }
    }

}


